import { Badge } from '@/components/ui/badge';

interface TransactionStatusBadgeProps {
  status: string;
  result?: string;
  className?: string;
}

// Capitalize first letter of a string
function capitalizeFirst(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Get badge variant based on status and result
function getStatusVariant(
  status: string,
  result?: string,
): 'green' | 'destructive' | 'secondary' | 'outline' {
  // Approved/succeeded - green
  if (result === 'approved' || status === 'succeeded') {
    return 'green';
  }

  // Failed/declined/rejected - red
  if (
    result === 'declined' ||
    status === 'declined' ||
    status === 'rejected' ||
    status === 'failed' ||
    result === 'canceled'
  ) {
    return 'destructive';
  }

  // Pending/processing - gray
  if (status === 'pending' || status === 'processing' || status === 'created') {
    return 'secondary';
  }

  // Default - outline
  return 'outline';
}

export function TransactionStatusBadge({ status, result, className }: TransactionStatusBadgeProps) {
  const variant = getStatusVariant(status, result);

  return (
    <Badge variant={variant} className={className}>
      {capitalizeFirst(status)}
    </Badge>
  );
}

// Separate component for transaction result badge
interface TransactionResultBadgeProps {
  result: string;
  className?: string;
}

export function TransactionResultBadge({ result, className }: TransactionResultBadgeProps) {
  const variant = result === 'approved' ? 'green' : result === 'declined' ? 'destructive' : 'outline';

  return (
    <Badge variant={variant} className={className}>
      {capitalizeFirst(result)}
    </Badge>
  );
}
